import analyticsUtils from './index.js'

export default function trackEvent(eventCategory, eventAction, eventLabel) {
  return analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.USER_CLICK,
    eventCategory,
    eventAction,
    eventLabel,
  })
}
